import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { template, uniqueId } from 'lodash';
import { Observable, of } from 'rxjs';
import { Breadcrumb } from './breadcrumb';

@Injectable()
export class BreadcrumbsResolver {
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<Breadcrumb[]> | Promise<Breadcrumb[]> | Breadcrumb[] {
    const data =
      route && route.routeConfig && route.routeConfig.data
        ? route.routeConfig.data
        : {};

    let path = this.getFullPath(route);
    let rawText = path;
    let ignore = false;
    let key = uniqueId();
    let href;

    if (data && data.breadcrumb) {
      if (typeof data.breadcrumb === 'string') {
        rawText = data.breadcrumb;
      } else {
        rawText = data.breadcrumb.label || data.label || path;
        ignore = data.breadcrumb.ignore || false;
        path = data.breadcrumb.path || path;
        key = data.breadcrumb.key || key;
        href = data.breadcrumb.href || href;
      }
    }

    return of([
      {
        ignore,
        path,
        label: this.stringFormat(rawText, route.data),
        key,
        href,
      },
    ]);
  }

  protected getFullPath(route: ActivatedRouteSnapshot): string {
    const relativePath = (segments: UrlSegment[]) =>
      segments.reduce((a, v) => (a += '/' + v.path), '');
    const fullPath = (routes: ActivatedRouteSnapshot[]) =>
      routes.reduce((a, v) => (a += relativePath(v.url)), '');
    return fullPath(route.pathFromRoot);
  }

  protected stringFormat(templateString: string, binding: any): string {
    const compiled = template(templateString, { interpolate: /{{(.+?)}}/g });
    return compiled(binding);
  }
}
